module.exports = __webpack_public_path__ + "img/fig05.185c1dff.jpg";